// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");

function make(set) {
  return {
          TAG: /* HaventGeneratedCombosYetForSet */0,
          _0: set
        };
}

function generateNextCombo(_generator) {
  while(true) {
    var generator = _generator;
    if (generator.TAG === /* HaventGeneratedCombosYetForSet */0) {
      var set = generator._0;
      return [
              set,
              {
                TAG: /* GeneratingSubsets */1,
                currSubsetAlgo: {
                  TAG: /* ElideSingleElementFrom */0,
                  set: set,
                  remainingSingleElementsToRemove: set
                },
                iterations: []
              }
            ];
    }
    var iterations = generator.iterations;
    var currSubsetAlgo = generator.currSubsetAlgo;
    if (typeof currSubsetAlgo === "number") {
      var match = ArrayUtils$SmartcutsMacros.dequeue(iterations);
      if (match === undefined) {
        return ;
      }
      _generator = {
        TAG: /* GeneratingSubsets */1,
        currSubsetAlgo: match[0],
        iterations: match[1]
      };
      continue ;
    }
    if (currSubsetAlgo.TAG === /* ElideSingleElementFrom */0) {
      var remainingSingleElementsToRemove = currSubsetAlgo.remainingSingleElementsToRemove;
      if (!remainingSingleElementsToRemove) {
        return dequeueAndGenerateNextCombo(iterations);
      }
      var singleMemberToRemove = remainingSingleElementsToRemove.hd;
      var set$1 = currSubsetAlgo.set;
      var combo = ListUtils$SmartcutsMacros.removeValue(singleMemberToRemove, set$1);
      var set$p = ListUtils$SmartcutsMacros.removeValue(singleMemberToRemove, set$1);
      var numFixed = List.length(set$1) - List.length(remainingSingleElementsToRemove) | 0;
      var tmp;
      if (numFixed !== 0) {
        var match$1 = ListUtils$SmartcutsMacros.splitAt(numFixed, set$p);
        var nonFixed = match$1[1];
        tmp = {
          TAG: /* CombineFixedWithCombosOfNonFixed */1,
          fixed: match$1[0],
          nonFixed: nonFixed,
          remainingNonFixed: nonFixed
        };
      } else {
        tmp = {
          TAG: /* ElideSingleElementFrom */0,
          set: set$p,
          remainingSingleElementsToRemove: set$p
        };
      }
      var nextGenerator_0 = {
        TAG: /* ElideSingleElementFrom */0,
        set: set$1,
        remainingSingleElementsToRemove: remainingSingleElementsToRemove.tl
      };
      var nextGenerator_1 = ArrayUtils$SmartcutsMacros.enqueue(tmp, iterations);
      var nextGenerator = {
        TAG: /* GeneratingSubsets */1,
        currSubsetAlgo: nextGenerator_0,
        iterations: nextGenerator_1
      };
      if (List.length(combo) !== 0) {
        return [
                combo,
                nextGenerator
              ];
      }
      _generator = nextGenerator;
      continue ;
    }
    var remainingNonFixed = currSubsetAlgo.remainingNonFixed;
    if (!remainingNonFixed) {
      return dequeueAndGenerateNextCombo(iterations);
    }
    var nonFixed$1 = currSubsetAlgo.nonFixed;
    var fixed = currSubsetAlgo.fixed;
    var combo$1 = List.append(fixed, ListUtils$SmartcutsMacros.removeValue(remainingNonFixed.hd, nonFixed$1));
    var nextNumFixed = List.length(fixed) + (List.length(nonFixed$1) - List.length(remainingNonFixed) | 0) | 0;
    var tmp$1;
    if (List.length(combo$1) === nextNumFixed) {
      tmp$1 = /* CombosGeneratedByAPrecedingIterator */0;
    } else {
      var match$2 = ListUtils$SmartcutsMacros.splitAt(nextNumFixed, combo$1);
      var nonFixed$p = match$2[1];
      tmp$1 = {
        TAG: /* CombineFixedWithCombosOfNonFixed */1,
        fixed: match$2[0],
        nonFixed: nonFixed$p,
        remainingNonFixed: nonFixed$p
      };
    }
    var nextGenerator_0$1 = {
      TAG: /* CombineFixedWithCombosOfNonFixed */1,
      fixed: fixed,
      nonFixed: nonFixed$1,
      remainingNonFixed: remainingNonFixed.tl
    };
    var nextGenerator_1$1 = ArrayUtils$SmartcutsMacros.enqueue(tmp$1, iterations);
    var nextGenerator$1 = {
      TAG: /* GeneratingSubsets */1,
      currSubsetAlgo: nextGenerator_0$1,
      iterations: nextGenerator_1$1
    };
    return [
            combo$1,
            nextGenerator$1
          ];
  };
}

function dequeueAndGenerateNextCombo(iterations) {
  var match = ArrayUtils$SmartcutsMacros.dequeue(iterations);
  if (match !== undefined) {
    return generateNextCombo({
                TAG: /* GeneratingSubsets */1,
                currSubsetAlgo: match[0],
                iterations: match[1]
              });
  }
  
}

exports.make = make;
exports.generateNextCombo = generateNextCombo;
exports.dequeueAndGenerateNextCombo = dequeueAndGenerateNextCombo;
/* ArrayUtils-SmartcutsMacros Not a pure module */
